import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import NivForm from './NivForm.js'

//New survey img
import new_survey_button from '../../Images/Healthform/New_survey.png';

class BreathingDisplayNewForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            displayBreathingFormPopup: false,
            scheduleVni: [],
            respiratoryRateTime: "min",
            leakageTime: "min"
        };

    }

    togglePopup = () => {
        if (this.props.breathing.niv_schedule !== undefined && this.props.breathing.niv_schedule.length > 0) {

            if (this.props.breathing.niv_schedule[this.props.breathing.niv_schedule.length - 1] !== undefined) {

                // get last breathing value
                let lastBreathingValue = this.props.breathing.niv_schedule

                // Fill VNI schedule with existing data
                this.state.scheduleVni = []         // empty existing state
                let scheduleVniTmp = lastBreathingValue
                if (typeof(scheduleVniTmp) === "string") {
                    scheduleVniTmp = JSON.parse(scheduleVniTmp)
                }
                if (typeof(scheduleVniTmp) === "string") {
                    scheduleVniTmp = JSON.parse(scheduleVniTmp)
                }
                if (scheduleVniTmp !== undefined && typeof(scheduleVniTmp) === "object") {
                scheduleVniTmp.forEach(part => {
                    let dateTmp1 = new Date(part.start)
                    this.state.scheduleVni.push(dateTmp1)
                    })
                }
            }
        }
        this.setState(
            { displayBreathingFormPopup: !this.state.displayBreathingFormPopup }
        )
    }

    //Display render
    render(){
        return (
            <div style={{ flex:1, flexDirection:'column', alignItems:'center', justifyContent:'center', paddingTop:"30%"}}>

                    {this.props.accountInformation.readOnly === true ?
                        null
                        :
                    <button onClick={this.togglePopup} style={{backgroundColor:"transparent"}}>
                        <img src={new_survey_button} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "35px"}} alt="new_survey_logo"/>
                    </button>
                    }
                    {this.state.displayBreathingFormPopup ?
                        <NivForm
                            cancelPopup={this.togglePopup}
                            id_patient={this.props.id_patient}
                            update={this.props.update}
                            BannerDisplayedAlerts={this.state.BannerDisplayedAlerts}
                            scheduleVni={this.state.scheduleVni}
                            respiratoryRateTime={this.state.respiratoryRateTime}
                            leakageTime={this.state.leakageTime}
                            start_date={this.props.start_date}
                            end_date={this.props.end_date}
                            screenSize={this.props.screenSize}
                        />
                        :
                        null
                    }
            </div>
        );
    }
}
export default (BreathingDisplayNewForm);